import { MutationTuple, useMutation } from '@apollo/client';

import {
  UPDATE_ASC_PROJECT_CAPITALIZABLE_PROJECT_CLUSTERING_OVERRIDE,
  UpdateAscProjectCapitalizableProjectClusteringOverrideMutation,
  UpdateAscProjectCapitalizableProjectClusteringOverrideMutationVariables,
} from '@neo.tax/shared';

export const useUpdateAscProjectCapitalizableProjectClusteringOverride = (): MutationTuple<
  UpdateAscProjectCapitalizableProjectClusteringOverrideMutation,
  UpdateAscProjectCapitalizableProjectClusteringOverrideMutationVariables
> =>
  useMutation<
    UpdateAscProjectCapitalizableProjectClusteringOverrideMutation,
    UpdateAscProjectCapitalizableProjectClusteringOverrideMutationVariables
  >(UPDATE_ASC_PROJECT_CAPITALIZABLE_PROJECT_CLUSTERING_OVERRIDE);
